import { RootPageState } from '@dtx-company/inter-app/src/redux/types'
import { usePageSelector } from '@dtx-company/inter-app/src/hooks/usePageSelector'

export function useClientHasMailchimpKey(): string {
  return usePageSelector((state: RootPageState) => state.pageEditorReducer.clientHasMaillchimpKey)
}
